// Clinical Operations Dashboard Module (Module L — BillingV2 Stage 2)
// Operational control across centers: workloads, backlog and risk distribution.

import ClinicalOperationsPage from "./pages/ClinicalOperationsPage";

// Export routes for AppRouter
export const clinicalOperationsRoutes = [
  {
    path: "/clinical-operations",
    element: <ClinicalOperationsPage />,
  },
];

// Export components for external use
export { default as ClinicalOperationsPage } from "./pages/ClinicalOperationsPage";
